<template>
  <div class="foldBtn-wrap" @click="foldSwitch" v-if="displayFold">
    {{ $t('common.unfold') }}
    <van-icon
      :name="'play-circle-o'"
      style="transform: rotate(90deg)"
      class="fold"
    />
  </div>
</template>

<script>
  export default {
    // props: ['datas', 'propName', 'index'], // datas: 数据源，数组；propName：折叠属性名；index：开始折叠下标
    props: {
      datas: {
        type: Array,
        default: () => [],
      },
      index: {
        type: Number,
        default: 0,
      },
      show: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        displayFold: true,
      }
    },
    computed: {
      foldData() {
        return this.datas && this.datas.length > 0
          ? this.datas.filter((_, idx) => idx * 1 <= this.index)
          : []
      },
    },
    watch: {
      show() {
        this.init()
      },
      foldData(val = [], oldVal = []) {
        // 数据改变时,为防止是否选中影响数据初始化,因此比对变化前后id的值(商品和通道都有id属性)
        const valString = val.map((item) => item.id).join('')
        const oldValString = oldVal.map((item) => item.id).join('')
        if (valString !== oldValString) {
          this.init()
        } else {
          this.$emit(
            'fold-switch',
            this.displayFold ? this.foldData : this.datas
          )
        }
      },
    },
    mounted() {
      this.init()
    },
    methods: {
      init() {
        this.displayFold = this.datas.length > this.index + 1
        this.$emit('fold-switch', this.foldData)
      },
      foldSwitch() {
        this.displayFold = false
        this.$emit('fold-switch', this.datas)
      },
    },
  }
</script>

<style lang="scss" scoped>
  .foldBtn-wrap {
    display: inline-block;
    font: 500 30px/30px Manrope-Medium, Manrope;
    color: rgba(153, 153, 153, 0.9);

    .fold {
      margin-left: 18px;
    }
  }
</style>
<style scoped lang="scss">
  @media screen and (min-device-width: 1080px) {
    @import './FoldSwitch_pc.scss';
  }
</style>
